import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import CookieBanner from "@/components/site/CookieBanner";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";

// Reset scroll to the top of the page on every route change (works with lenis).
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const toTop = () => {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    };
    toTop();
    const id = requestAnimationFrame(toTop);
    return () => cancelAnimationFrame(id);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Legal type="privacy" />} />
          <Route path="/cookie" element={<Legal type="cookie" />} />
          <Route path="/termini" element={<Legal type="termini" />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
